const ROUTE_PATHS = {
  signIn: "/",
  pressList: "/press-list",
  ctgList: "/ctg-list",
  publicationList: "/publication-list",
  pressClassification: "/press-classification",
  fillInTable: "/fill-in-table",
  editArticle: "/edit-article",
  insertImage: "/insert-image",
  redirect: "/redirect",
  ctgFillInTable: "/ctg-fill-in-table",
  publicationFillInTable: "/publication-fill-in-table",
} as const;

export { ROUTE_PATHS };
